// extracted by mini-css-extract-plugin
export var loader = "Loader-module--loader--25fad";
export var visible = "Loader-module--visible--e37c6";